// Ajustes > Idioma e moeda (0.67, texto 05 D3): saiu da antiga "Configuração geral". Tudo encolhido.
// 0.67.2 (texto 07 C4): lista de moedas com busca, "Mais usadas", a do país e "Todas" por nome; linha "US$ Dólar americano · USD".
import { useState } from 'react';
import { Pressable, ScrollView, Text, TextInput, View } from 'react-native';
import { Sheet } from '../../components/ui';
import { C, useCores } from '../../components/theme';
import { IDIOMAS, setIdioma, t, useIdioma } from '../../lib/i18n';
import { linhaMoeda, listaMoedas, rotuloMoeda as rotulo } from '../../lib/moeda';
import { moedaDe, setMoeda } from '../../store/financas';
import { useDoc } from '../../store/store';
import { Bloco, Dica, LinhaEscolha, LinhaOpcoes } from '../../components/ajustes/Linhas';
import { ROLAGEM_TECLADO } from '../../components/teclado';

/** "R$ Real brasileiro" (símbolo e nome no idioma do app, sem repetir o código). */
export const rotuloMoeda = (x: string, lang: string) => rotulo(x, lang);

function ListaMoedas({ visivel, atual, lang, onFechar }: { visivel: boolean; atual: string; lang: string; onFechar: () => void }) {
  const { accent } = useCores();
  const [busca, setBusca] = useState('');
  const l = listaMoedas(lang, busca);
  const fechar = () => { setBusca(''); onFechar(); };
  const titulo = (s: string) => <Text style={{ color: C.sub, fontSize: 12, fontWeight: '700', letterSpacing: 0.8, marginTop: 12, marginBottom: 4 }}>{s.toUpperCase()}</Text>;
  const linha = (x: string, k: string) => (
    <Pressable key={k + x} onPress={() => { setMoeda(x); fechar(); }}
      style={({ pressed }) => ({ flexDirection: 'row', alignItems: 'center', gap: 10, paddingVertical: 12, paddingHorizontal: 12, borderRadius: 10, backgroundColor: pressed ? C.card2 : 'transparent' })}>
      <Text style={{ color: C.text, flex: 1, fontSize: 15, fontWeight: x === atual ? '700' : '400' }}>{linhaMoeda(x, lang)}</Text>
      {x === atual && <Text style={{ color: accent, fontWeight: '900', fontSize: 16 }}>✓</Text>}
    </Pressable>
  );
  const nada = !l.maisUsadas.length && !l.doPais.length && !l.todas.length;
  return (
    <Sheet visible={visivel} onClose={fechar} title={t('Moeda')}>
      <View style={{ paddingHorizontal: 16, paddingBottom: 6 }}>
        <TextInput value={busca} onChangeText={setBusca} placeholder={'🔎 ' + t('Buscar moeda')} placeholderTextColor={C.mute} autoCorrect={false}
          clearButtonMode="while-editing" style={{ backgroundColor: C.card, color: C.text, borderRadius: 12, paddingHorizontal: 14, paddingVertical: 10, fontSize: 15 }} />
      </View>
      <ScrollView {...ROLAGEM_TECLADO} keyboardShouldPersistTaps="handled" contentContainerStyle={{ paddingHorizontal: 16, paddingBottom: 40 }}>
        {!!l.maisUsadas.length && <>{titulo(t('Mais usadas'))}<View style={{ backgroundColor: C.card, borderRadius: 14 }}>{l.maisUsadas.map(x => linha(x, 'm'))}</View></>}
        {!!l.doPais.length && <>{titulo(t('Do seu país'))}<View style={{ backgroundColor: C.card, borderRadius: 14 }}>{l.doPais.map(x => linha(x, 'p'))}</View></>}
        {!!l.todas.length && <>{titulo(t('Todas'))}<View style={{ backgroundColor: C.card, borderRadius: 14 }}>{l.todas.map(x => linha(x, 't'))}</View></>}
        {nada && <Text style={{ color: C.sub, textAlign: 'center', marginTop: 24 }}>{t('Nenhuma moeda encontrada')}</Text>}
      </ScrollView>
    </Sheet>
  );
}

export default function IdiomaMoeda() {
  const lang = useIdioma();
  const fin = useDoc('financas');
  const atual = moedaDe(fin);
  const [lista, setLista] = useState(false);
  const idi = IDIOMAS.find(i => i.id === lang);
  return (<>
    <Bloco titulo={t('Idioma')}>
      <LinhaOpcoes icone="🌐" titulo={t('Idioma')} valor={lang} rotulo={idi ? `${idi.bandeira} ${idi.nome}` : ''}
        opcoes={IDIOMAS.map(i => [i.id, `${i.bandeira} ${i.nome}`] as [typeof i.id, string])} onEscolher={setIdioma} />
      <Dica>{t('O idioma vale para este dispositivo. Os dados que você digitou não são traduzidos.')}</Dica>
    </Bloco>
    <Bloco titulo={t('Moeda')}>
      <LinhaEscolha icone="💲" titulo={t('Moeda')} valor={rotuloMoeda(atual, lang)} onPress={() => setLista(true)} />
      <Dica>{t('Vale para os valores de todas as abas (Finanças, aluguel, mensalidades...).')}</Dica>
    </Bloco>
    <ListaMoedas visivel={lista} atual={atual} lang={lang} onFechar={() => setLista(false)} />
  </>);
}
